﻿import * as defaults from '../defaults';

export function parseGraphic(graphic) {
    let result = {};

    if (graphic.Size != null) {
        result.radius = 0.5 * graphic.Size;
    } else {
        result.radius = 0.5 * defaults.DEFAULT_MARK_SIZE;
    }

    if (graphic.Rotation != null) {
        result.rotation = graphic.Rotation;
    } else {
        result.rotation = defaults.DEFAULT_MARK_ROTATION;
    }

    if (graphic.Displacement != null && graphic.Displacement.DisplacementX != null) {
        result.displacementX = graphic.Displacement.DisplacementX;
    } else {
        result.displacementX = defaults.DEFAULT_MARK_DISPLACEMENT_X;
    }

    if (graphic.Displacement != null && graphic.Displacement.DisplacementY != null) {
        result.displacementY = graphic.Displacement.DisplacementY;
    } else {
        result.displacementY = defaults.DEFAULT_MARK_DISPLACEMENT_Y;
    }

    if (graphic.Opacity != null && graphic.Opacity != null) {
        result.opacity = graphic.Opacity;
    } else {
        result.opacity = defaults.DEFAULT_MARK_FILL_OPACITY;
    }

    return result;
}

export function parseMark(mark) {
    let result = {};

    if (mark.Fill != null && mark.Fill.styling != null && mark.Fill.styling.fill != null && mark.Fill.styling.fill.trim() != '') {
        result.fillColor = mark.Fill.styling.fill;
    } else {
        result.fillColor = defaults.DEFAULT_MARK_FILL_COLOR;
    }

    if (mark.Fill != null && mark.Fill.styling != null && mark.Fill.styling.fillOpacity != null) {
        result.fillOpacity = mark.Fill.styling.fillOpacity;
    } else {
        result.fillOpacity = defaults.DEFAULT_MARK_FILL_OPACITY;
    }

    if (mark.Stroke != null && mark.Stroke.styling != null && mark.Stroke.styling.stroke != null && mark.Stroke.styling.stroke.trim() != '') {
        result.strokeColor = mark.Stroke.styling.stroke;
    } else {
        result.strokeColor = defaults.DEFAULT_MARK_STROKE_COLOR;
    }

    if (mark.Stroke != null && mark.Stroke.styling != null && mark.Stroke.styling.strokeOpacity != null) {
        result.strokeOpacity = mark.Stroke.styling.strokeOpacity;
    } else {
        result.strokeOpacity = defaults.DEFAULT_MARK_STROKE_OPACITY;
    }

    if (mark.Stroke != null && mark.Stroke.styling != null && mark.Stroke.styling.strokeWidth != null) {
        result.strokeWidth = mark.Stroke.styling.strokeWidth;
    } else {
        result.strokeWidth = defaults.DEFAULT_MARK_STROKE_WIDTH;
    }

    return result;
}

export function parseAnchorPoint(graphic) {
    let result = {};

    if (graphic.AnchorPoint != null && graphic.AnchorPoint.AnchorPointX != null) {
        result.anchorPointX = graphic.AnchorPoint.AnchorPointX * 1;
    } else {
        result.anchorPointX = defaults.DEFAULT_MARK_ANCHOR_POINT_X;
    }

    if (graphic.AnchorPoint != null && graphic.AnchorPoint.AnchorPointY != null) {
        result.anchorPointY = graphic.AnchorPoint.AnchorPointY * 1;
    } else {
        result.anchorPointY = defaults.DEFAULT_MARK_ANCHOR_POINT_Y;
    }

    return result;
}